import React from 'react';
import { Link } from 'react-router-dom';
import { Rocket } from 'lucide-react';
import { useTenant } from '../context/TenantContext';

const Footer: React.FC = () => {
  const { brandName, isWhiteLabeled } = useTenant();
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-12">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 bg-gradient-brand rounded-lg flex items-center justify-center">
                <Rocket className="h-4 w-4 text-white" />
              </div>
              <span className="text-sm font-bold text-slate-800 tracking-tight">{brandName || 'Aurelian Marketing Engine'}</span>
            </div>
            <p className="text-xs text-slate-400 max-w-sm leading-relaxed">
              An AI-powered content marketing automation platform that unifies research, content generation,
              publishing, email marketing, analytics, and more into a single command center.
            </p>
          </div>

          <div>
            <h4 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3 font-mono">Platform</h4>
            <ul className="space-y-2">
              <li><a href="/dashboard" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Dashboard</a></li>
              <li><a href="/research" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Research Hub</a></li>
              <li><a href="/generate" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Content Factory</a></li>
              <li><a href="/publishing" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Publishing Hub</a></li>
              <li><a href="/analytics" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Analytics</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-3 font-mono">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/legal/terms" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Terms of Service</Link></li>
              <li><Link to="/legal/privacy" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal/cookies" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Cookie Policy</Link></li>
              <li><Link to="/legal/licensing" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Licensing Agreement</Link></li>
              <li><Link to="/legal/affiliate" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">Affiliate Terms</Link></li>
              <li><Link to="/legal/compliance" className="text-xs text-slate-400 hover:text-primary-600 transition-colors">GDPR Compliance</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-300 font-mono">
            &copy; {new Date().getFullYear()} {brandName || 'Aurelian Marketing Engine'}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            {!isWhiteLabeled && (
              <>
                <a href="https://www.aurelianmarketingengine.com" target="_blank" rel="noopener noreferrer" className="text-[10px] text-slate-400 hover:text-primary-600 transition-colors font-mono">www.aurelianmarketingengine.com</a>
              </>
            )}
            <span className="text-[10px] text-slate-300 font-mono">v2.0</span>
            {!isWhiteLabeled && <span className="text-[10px] text-slate-300 font-mono">Powered by AME</span>}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
